import { render, staticRenderFns } from "./SegmentationMapLayer.vue?vue&type=template&id=3900040e&scoped=true"
import script from "./SegmentationMapLayer.vue?vue&type=script&lang=js"
export * from "./SegmentationMapLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3900040e",
  null
  
)

export default component.exports